import Link from "next/link";
import { ArrowRight } from "@/components/icons";
import { GREEN } from "@/lib/constants";
import { cn } from "@/lib/utils";

interface Props {
  href: string;
  label: string;
  badge?: string;
  className?: string;
  /** "white" renders a solid white pill in both themes, with pinned dark text. */
  variant?: "default" | "white";
  onClick?: () => void;
}

export default function AnnouncementChip({
  href,
  label,
  badge = "New",
  className,
  variant = "default",
  onClick,
}: Props) {
  const isWhite = variant === "white";
  return (
    <Link
      href={href}
      onClick={onClick}
      className={cn(
        "group inline-flex items-center gap-2 rounded-full border px-3.5 py-1.5 text-xs font-medium transition-colors sm:text-sm",
        isWhite
          ? "border-black/10 bg-white shadow-sm hover:bg-zinc-100"
          : "border-border bg-foreground/5 hover:bg-foreground/10",
        className
      )}
    >
      <span
        className="rounded-full px-2 py-0.5 text-[10px] font-semibold"
        style={
          isWhite
            ? { backgroundColor: "#2563eb14", color: "#2563eb" }
            : { backgroundColor: `${GREEN}1A`, color: "var(--brand-green)" }
        }
      >
        {badge}
      </span>
      <span
        className={cn(
          "transition-colors",
          isWhite
            ? "text-zinc-600 group-hover:text-zinc-900"
            : "text-muted-foreground group-hover:text-foreground"
        )}
      >
        {label}
      </span>
      <ArrowRight
        size={12}
        className={cn(
          "transition-all group-hover:translate-x-0.5",
          isWhite
            ? "text-zinc-500 group-hover:text-zinc-900"
            : "text-muted-foreground group-hover:text-foreground"
        )}
        aria-hidden="true"
      />
    </Link>
  );
}
